export default __webpack_public_path__ + "static/148-min-min-8f3f49553ed739f53da6f082e27ea4a4.jpg";